import { FC } from 'react';
import { DegreeCard } from '../DegreeCard/DegreeCard';
import { DegreeWithEnrollment } from '../../types';

interface DegreeGridProps {
  degrees: DegreeWithEnrollment[];
  emptyMessage?: string;
}

export const DegreeGrid: FC<DegreeGridProps> = ({
  degrees,
  emptyMessage = 'No degrees available',
}) => {
  if (!degrees.length) {
    return (
      <div className="flex items-center justify-center py-12">
        <p className="text-gray-500 text-lg">{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {degrees.map((degree) => (
        <DegreeCard
          key={degree.id}
          degree={degree}
          progress={degree.progress}
          isEnrolled={!!degree.isEnrolled}
        />
      ))}
    </div>
  );
};
